import * as restErrorHandler from "@sharedJS/restErrorHandler";
import * as rest from "@sharedJS/rest";
import commonPopup from "@JS/shop/10-login-component/commonPopup";
import OcmMessenger from "ocm_mercurius_messenger";
import { messengerPublicationTypes } from "@ocm/services/services.constants.js";

/* global facebookAppVersion */
/* global facebookAppId */

// DOM
let $facebookAuthenticateBtn;
let $facebookReauthenticateBtn;
let $loginForm;

const facebookAuthenticateBtn = ".js-login-facebook";
const facebookReauthenticateBtn = ".js-reauthenticate-facebook";
const loginFormId = "#facebook-login-form";

function _setVars() {
	// DOM
	$facebookAuthenticateBtn = $(facebookAuthenticateBtn);
	$facebookReauthenticateBtn = $(facebookReauthenticateBtn);
	$loginForm = $(loginFormId);
}

function init() {
	// Bind Actions
	document.addEventListener("click", (event) => {
		if (event.target.matches(facebookAuthenticateBtn)) {
			event.preventDefault();
			authenticateWithFacebookAction();
		}
		if (event.target.matches(facebookReauthenticateBtn)) {
			event.preventDefault();
			reauthenticateWithFacebookAction();
		}
	});
}

function authenticateWithFacebookAction() {
	_setVars();
	if (typeof FB !== "object") {
		return false;
	}

	const scope = $facebookAuthenticateBtn.attr("facebookUserInfoScope");
	FB.getLoginStatus((response) => {
		if (response.status === "connected") {
			const accessToken = response.authResponse.accessToken;
			const facebookAction = $facebookAuthenticateBtn.attr("facebookAction");
			const facebookData = _createFacebookData(
				accessToken,
				response.authResponse.userID,
				facebookAction,
				"authenticate"
			);
			_doServerAuthentication(facebookData);
		} else if (response.status === "unknown") {
			_facebookLogin({ auth_type: "rerequest", scope, return_scopes: true }, "authenticate");
		} else {
			_facebookLogin({ scope, return_scopes: true }, "authenticate");
		}
	}, false);
}

function _createFacebookData(accessToken, userID, action, context) {
	return {
		facebookUrl: action,
		accessToken,
		facebookId: userID,
		context,
	};
}

function reauthenticateWithFacebookAction() {
	_setVars();
	if (typeof FB !== "object") {
		return false;
	}
	const scope = $facebookReauthenticateBtn.attr("facebookUserInfoScope");
	_facebookReAuth({ auth_type: "reauthenticate", scope }, "reauthenticate");
}

function _facebookLogin(fbParameters, context) {
	removeErrors();

	if (_isInThirdPartyApp()) {
		const callbackUrl = $facebookAuthenticateBtn.attr("facebookInThirdPartyAppAuthAction");
		const authenticationUrl = _buildFacebookThirdPartyAppAuthenticationUrl(callbackUrl, fbParameters);
		window.location.replace(authenticationUrl);
	} else {
		FB.login((loginResponse) => {
			const response = loginResponse;
			if (response.authResponse) {
				const facebookAction = $facebookAuthenticateBtn.attr("facebookAction");
				const facebookData = _createFacebookData(
					response.authResponse.accessToken,
					response.authResponse.userID,
					facebookAction,
					context
				);
				_doServerAuthentication(facebookData);
			}
		}, fbParameters);
	}
}

function _facebookReAuth(fbParameters, context) {
	removeErrors();

	if (_isInThirdPartyApp()) {
		const callbackUrl = $facebookReauthenticateBtn.attr("facebookInThirdPartyAppAuthAction");
		const authenticationUrl = _buildFacebookThirdPartyAppAuthenticationUrl(callbackUrl, fbParameters);
		window.location.replace(authenticationUrl);
	} else {
		const oldToken = FB.getAccessToken();

		FB.login((loginResponse) => {
			const response = loginResponse;
			if (response.authResponse && response.authResponse.accessToken != oldToken) {
				const facebookAction = $facebookReauthenticateBtn.attr("facebookAction");
				const facebookData = _createFacebookData(
					response.authResponse.accessToken,
					response.authResponse.userID,
					facebookAction,
					context
				);
				_doServerReAuthentication(facebookData);
			}
		}, fbParameters);
	}
}

function _doServerAuthentication(facebookData) {
	facebookData.formId = loginFormId;
	facebookData.rememberMe = $facebookAuthenticateBtn.attr("isRememberMe");
	_facebookAjaxRequest(facebookData);
}

function _doServerReAuthentication(facebookData) {
	facebookData.formId = loginFormId;
	_facebookAjaxRequest(facebookData);
}

function _facebookAjaxRequest(facebookData) {
	removeErrors();

	const postActionExists = $("#master-common-layer").attr("data-postActionJs");
	let dataType = "json";

	if (postActionExists) {
		dataType = "html";
	}
	$.ajax({
		url: facebookData.facebookUrl,
		dataType,
		type: "POST",
		data: facebookData,
	})
		.done((responseData) => {
			if (postActionExists) {
				commonPopup.closeLayer();
				commonPopup.doStartPopupPostAction(responseData);
			} else {
				rest.handleRedirect(
					{ responseJSON: { redirectUrl: responseData.redirectUrl } },
					{ saveRedirectToHistory: false }
				);
			}
		})
		.fail((responseData) => {
			FB.logout((response) => {
				console.log(
					`facebook logout to reset the connection state done. At the next login the authentication state will be 'unknown' -> reauthentication is possible`,
					response
				);
			});
			restErrorHandler.handleError(responseData, facebookData.formId, _facebookAjaxRequest, facebookData);
			OcmMessenger.publish(messengerPublicationTypes.FACEBOOK_LOGIN, {
				type: "ERROR",
				detail: responseData.responseJSON.globalErrorMessages,
			});
		});
}

//--------------------------
// Helper
//--------------------------
function removeErrors() {
	$loginForm.empty();
}

function _isInThirdPartyApp() {
	const useragent = navigator.userAgent || navigator.vendor || window.opera;
	const webView = "WebView";
	const iOS = "(iPhone|iPod|iPad)(?!.*Safari/)";
	const android = "Android.*(wv|.0.0.0)";
	const rules = [webView, iOS, android];
	const regex = new RegExp(`(${rules.join("|")})`, "ig");
	return useragent.match(regex);
}

function _buildFacebookThirdPartyAppAuthenticationUrl(callbackUrl, fbParameters) {
	const urlPath = `https://www.facebook.com/${facebookAppVersion}/dialog/oauth`;
	if (typeof window.URL === "function") {
		const url = new URL(urlPath);
		url.searchParams.append(`client_id`, facebookAppId);
		url.searchParams.append(`redirect_uri`, `${window.location.origin}${callbackUrl}`);

		for (const propertyName in fbParameters) {
			url.searchParams.append(propertyName, fbParameters[propertyName]);
		}
		return url.toString();
	}

	// QuickFix für IE TUB-9273
	const callbackEncoded = encodeURIComponent(callbackUrl);
	let urlString = `${urlPath}?client_id=${facebookAppId}&redirect_uri=${window.location.origin}${callbackEncoded}`;
	for (const propertyName in fbParameters) {
		const _property = propertyName;
		const _propertyValue = fbParameters[propertyName];
		urlString = `${urlString}&${_property}=${_propertyValue}`;
	}
	return urlString;
}

export { init, authenticateWithFacebookAction, reauthenticateWithFacebookAction };
